var Backbone = require('backbone'),
    ZoomDropDown = require('./zoomDD'),
    BabySitterView = require('../../../../common/BabySitterView');

module.exports = BabySitterView.extend({
    template: require('./zoom.hbs'),
    serializeData: function() {
        return {
            initialValue: this.model.getFriendlyScaleValue()
        };
    },
    onRender: function() {
        var vCh = this.options.vChannel;
        this.children.add( new ZoomDropDown({
            el: this.ui.scaleSelect,
            vChannel: vCh,
            model: this.model,
            ddOptions: {
                isSelect: true,
                isSelectForceChangeOnClick: 1, // DVBC-1727
                activeClass: 'active popupOpen', //(want both)
                container: vCh.request('getWrapper'),
            }
        }).render() );
    },
    ui: {
        scaleSelect:    '.scaleSelect',
        zoomInBtn:      '.zoomin',
        zoomOutBtn:     '.zoomout'
    },
    events: function() {
        var vCh = this.options.vChannel;
        return {
            'click @ui.zoomInBtn':  _.bind(vCh.command, vCh, 'zoomIn'),
            'click @ui.zoomOutBtn': _.bind(vCh.command, vCh, 'zoomOut')
        };
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerCenter/zoom/zoom.js
 ** module id = 720
 ** module chunks = 0
 **/